import { render, staticRenderFns } from "./ReporteIngresosTabla.vue?vue&type=template&id=4d6082c4"
import script from "./ReporteIngresosTabla.vue?vue&type=script&lang=js"
export * from "./ReporteIngresosTabla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports